import { IntegratorRevenueSummaryResponse } from '@/DTOs/integrators';

export const mockIntegratorRevenueSummary: IntegratorRevenueSummaryResponse = {
  spreadEarnings: 150.0,
  tpv: 500000.0,
};
